export const normalizeRole = (role) => {
    const raw = typeof role === "string" ? role : role?.title || role?.name || "";
    const value = String(raw).trim().toUpperCase();
    if (!value) {
        return "";
    }
    return value.startsWith("ROLE_") ? value : `ROLE_${value}`;
};

const roleSource = (user) => {
    if (Array.isArray(user?.roles) && user.roles.length > 0) {
        return user.roles;
    }
    if (Array.isArray(user?.role)) {
        return user.role;
    }
    return user?.role ? [user.role] : [];
};

export const getRoleTitles = (user) => {
    return roleSource(user)
        .map((role) => (typeof role === "string" ? role : role?.title || role?.name))
        .filter(Boolean);
};

export const getPermissions = (user) => {
    if (!Array.isArray(user?.permissions)) {
        return [];
    }
    return user.permissions.filter((permission) => typeof permission === "string" && permission);
};

export const hasPermission = (user, permission) => {
    if (!permission) {
        return true;
    }
    const permissions = getPermissions(user);
    return permissions.includes("*") || permissions.includes(permission);
};

/**
 * Строгая проверка ролей после появления /api/v2/me. Если роли неизвестны —
 * доступ закрыт. Административные права можно выдать и через permissions: "*".
 */
export const hasAnyRole = (user, roles) => {
    if (!roles || roles.length === 0) {
        return true;
    }
    if (hasPermission(user, "*")) {
        return true;
    }
    const granted = getRoleTitles(user).map(normalizeRole);
    if (granted.length === 0) {
        return false;
    }
    const required = roles.map(normalizeRole);
    return required.some((role) => granted.includes(role));
};

